import { createFileRoute, } from '@tanstack/react-router';
import { Login, } from '../../pages/Login.js';
export const Route = createFileRoute('/login')({
    component: Login,
});
//# sourceMappingURL=login.js.map